module.exports = __webpack_public_path__ + "img/no-semi-vector.444e9a70.png";